import { Award } from "lucide-react";

const MASKY_FRONT = "https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/aeku2q6d_masky%20front%20on.png";
const MASKY_LOGO = "https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/nv7abkas_masky%20logo.png";

export default function MeetMaskySection() {
  return (
    <section
      id="meet-masky"
      className="py-20 bg-white"
      data-testid="meet-masky-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 bg-[#D4A857]/10 text-[#D4A857] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide font-['Montserrat'] mb-4">
            <Award size={16} />
            Say Hello!
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A1A2F] font-['Montserrat']">
            Meet <span className="text-[#D4A857]">Masky!</span>
          </h2>
        </div>

        {/* Masky Visual Showcase */}
        <div className="flex flex-col items-center mb-8" data-testid="masky-showcase">
          <div className="w-full max-w-md sm:max-w-lg flex flex-col items-center">
            <img
              src={MASKY_LOGO}
              alt="MASKY logo"
              className="w-44 sm:w-52"
              data-testid="masky-logo"
            />
            <img
              src={MASKY_FRONT}
              alt="Masky - Your friendly fencing mascot"
              className="w-full"
              data-testid="masky-image"
            />
          </div>
        </div>

        {/* Two-column: Description + Promises */}
        <div className="grid md:grid-cols-2 gap-8 items-start">
          <div className="space-y-4 text-gray-600 text-lg leading-relaxed font-['Lato']">
            <p>
              <span className="font-bold text-[#0A1A2F]">Masky</span> is our friendly fencing mascot — 
              part coach, part cheerleader, and <span className="text-[#3FA9F5] font-semibold">always ready 
              to help new fencers feel brave, confident, and excited!</span>
            </p>
            <p>
              Look out for Masky's tips and encouragement throughout your <span className="font-bold text-[#0A1A2F]">Olympic-style fencing</span> journey. 
              Whether you're stepping onto the piste for the first time or perfecting your footwork, 
              Masky is there to cheer you on every step of the way.
            </p>
          </div>

          <div className="bg-[#0A1A2F] rounded-lg p-6 text-white">
            <p className="font-bold text-[#D4A857] mb-4 font-['Montserrat'] uppercase tracking-wide text-sm">Masky's Promise to You:</p>
            <div className="grid grid-cols-2 gap-3">
              {[
                "Make you feel welcome",
                "Celebrate every win",
                "Share helpful tips",
                "Keep it fun!"
              ].map((promise, i) => (
                <div key={i} className="flex items-center gap-2">
                  <span className="text-[#D4A857]">&#10003;</span>
                  <span className="text-sm font-['Lato']">{promise}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
